import { Component, OnInit } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {RestService} from '../shared/rest/rest.service';
import {EnvironmentService} from 'bos-commons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public htmlContent;

  constructor(private env: EnvironmentService, private sanitizer: DomSanitizer, private restService: RestService) {}

  ngOnInit(): void {
    this.env.isLoaded.subscribe(value => {
      if(value) {
        const footerUrl = this.env.environment.backendBaseUrl + "/html/page/FOOTER?anyLanguage=true";
        this.restService.getContent(footerUrl).then(body => {
          this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(body);
        }, error => console.debug("there is no footer:", error))
    }});
  }

}
